<template>
  <div class="sections">
    <section
      v-for="(section, index) in sections"
      :key="sectionKey(index)"
      :class="sectionClasses(section)"
    >
      <template v-if="section.type === 'core-embed'">
        <vue-embedplayer :media="section"></vue-embedplayer>
      </template>
      <template v-if="section.type === 'audio'">
        <vue-audioplayer :media="section"></vue-audioplayer>
      </template>
      <template v-if="isTextBlock(section)">
        <text-block :section="section"></text-block>
      </template>
      <template v-if="isImageSlider(section)">
        <vue-slideshow :images="section.items" :sizes="sizes" :speed="5000"></vue-slideshow>
      </template>
      <template v-if="isIconList(section)">
        <icon-list :items="section.items"></icon-list>
      </template>
    </section>
  </div>
</template>
<script>
import VueEmbedplayer from "./VueEmbedplayer";
import VueAudioplayer from "./VueAudioplayer";
import VueSlideshow from "./VueSlideshow";
import TextBlock from "./TextBlock";
import IconList from "./IconList";
import config from "../config/config";

export default {
  name: "SectionList",
  components: {
    VueEmbedplayer,
    VueAudioplayer,
    TextBlock,
    VueSlideshow,
    IconList
  },
  props: {
    sections: {
      type: Array
    },
    id: {
      type: Number,
      default: 0
    }
  },
  computed: {
    sizes() {
      let sizes = [];
      if (config.imageStyles) {
        if (config.imageStyles.standard) {
          sizes = config.imageStyles.standard;
        }
      }
      return sizes;
    }
  },
  methods: {
    sectionClasses(section) {
      let cls = ["section"];
      cls.push(section.type);
      if (section.subtype) {
        cls.push(section.subtype);
      }
      return cls;
    },
    sectionKey(index) {
      return "section-" + this.id + "-" + index;
    },
    isTextBlock(section) {
      switch (section.type) {
        case "text":
        case "quote":
          return true;
        default:
          return false;
      }
    },
    isImageSlider(section) {
      switch (section.type) {
        case "gallery":
          return true;
        case "advgb":
          switch (section.subtype) {
            case "images-slider":
              return true;
            default:
              return false;
          }
        default:
          return false;
      }
    },
    isIconList(section) {
      let valid = false;
      let typeMatched = false;

      if (section.subtype) {
        switch (section.subtype) {
          case "iconlist":
          case "icon-list":
            typeMatched = true;
            break;
        }
        if (typeMatched) {
          if (section.items) {
            if (section.items instanceof Array) {
              valid = section.items.length > 0;
            }
          }
        }
      }
      return valid;
    }
  }
};
</script>